import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,  // 60s，AI 对话可能耗时较长
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器 - 添加token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// 技能相关API
export const skillsApi = {
  // 获取技能列表
  getSkills: (params) => api.get('/skills', { params }),
  
  // 获取技能详情
  getSkillDetail: (id) => api.get(`/skills/${id}`),
  
  // 获取分类列表
  getCategories: () => api.get('/skills/categories'),
  
  // 获取热门技能
  getHotSkills: () => api.get('/skills/hot'),
  
  // 获取官方推荐
  getRecommended: () => api.get('/skills/recommended'),
  
  // 创建技能
  createSkill: (data) => api.post('/skills', data),
  
  // 下载技能
  downloadSkill: (id) => api.post(`/skills/${id}/download`),
};

// 专家相关API
export const expertsApi = {
  // 获取专家列表
  getExperts: (params) => api.get('/experts', { params }),
  
  // 获取专家详情
  getExpert: (id) => api.get(`/experts/${id}`),
  
  // 获取专家类型
  getTypes: () => api.get('/experts/types'),
  
  // 获取官方专家
  getOfficialExperts: () => api.get('/experts/official'),
  
  // 获取高评分专家
  getTopRated: () => api.get('/experts/top-rated'),
  
  // 预约咨询
  consultExpert: (id, data) => api.post(`/experts/${id}/consult`, data),
  
  // 获取专家建议
  getExpertSuggestions: (id) => api.get(`/expert-chat/${id}/suggestions`),
  
  // 与专家对话
  chatWithExpert: (id, data) => api.post(`/expert-chat/${id}`, data),
  
  // 清空会话
  clearExpertChat: (id, data) => api.post(`/expert-chat/${id}/clear`, data),
};

// 认证相关API
export const authApi = {
  // 注册
  register: (data) => api.post('/auth/register', data),
  
  // 登录
  login: (data) => api.post('/auth/login', data),
  
  // 获取当前用户
  getMe: () => api.get('/auth/me'),
  
  // 更新用户信息
  updateMe: (data) => api.put('/auth/me', data),
  
  // 修改密码
  changePassword: (data) => api.put('/auth/password', data),
};

// 上传相关API
export const uploadApi = {
  // 上传技能包
  uploadSkill: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload/skill', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  
  // 上传图标
  uploadIcon: (file) => {
    const formData = new FormData();
    formData.append('icon', file);
    return api.post('/upload/icon', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

// SCAR 外部技能搜索与导入API
export const scarApi = {
  // 获取外部源列表
  getSources: () => api.get('/scar/sources'),
  
  // 搜索外部技能
  searchSkills: (source, keyword, page = 1, limit = 20) =>
    api.get('/scar/search', { params: { source, keyword, page, limit } }),
  
  // 导入技能
  importSkill: (data) => api.post('/scar/import', data),
  
  // 获取导入记录
  getImportLogs: (page = 1, limit = 20) =>
    api.get('/scar/import-logs', { params: { page, limit } }),
};

export default api;
